module.exports = __webpack_public_path__ + "static/vtt2-c4bdf95d1ff16812f30a69181377681f.jpg";